import React from 'react';
import PropTypes from 'prop-types';
import clx from 'classnames';

export default class TdComponent extends React.Component {
  static defaultProps = {
    colSpan: undefined,
    rowSpan: undefined,
    className: undefined,
  };

  static propTypes = {
    colSpan: PropTypes.number,
    rowSpan: PropTypes.number,
    className: PropTypes.string,
  };

  render() {
    const { colSpan, rowSpan, className, ...props } = this.props;

    if (colSpan === 0 || rowSpan === 0) {
      return null;
    }

    return (
      <td colSpan={colSpan} rowSpan={rowSpan} className={clx('rt-td', className)} {...props} />
    );
  }
}
